import { carouselItems } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=dramatic%20warm%20toned%20entertainment%20news%20collage%2C%20crimson%20and%20dark%20amber%20mood%2C%20mysterious%20night%20scene%20with%20soft%20bokeh%20lights%2C%20editorial%20photography%20style%2C%20no%20text%2C%20abstract%20celebrity%20vibe&width=600&height=600&seq=carousel-01-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dark%20moody%20social%20media%20aesthetic%2C%20warm%20crimson%20glow%2C%20abstract%20internet%20drama%20theme%2C%20soft%20dramatic%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20mysterious%20atmosphere&width=600&height=600&seq=carousel-02-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=warm%20toned%20abstract%20entertainment%20scene%2C%20dark%20amber%20and%20crimson%20gradients%2C%20soft%20bokeh%2C%20cinematic%20mood%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious%20elegant&width=600&height=600&seq=carousel-03-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=dramatic%20warm%20backstage%20atmosphere%2C%20crimson%20and%20gold%20tones%2C%20abstract%20showbiz%20aesthetic%2C%20soft%20spotlight%20glow%2C%20editorial%20style%2C%20no%20text&width=600&height=600&seq=carousel-04-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=mysterious%20dark%20warm%20toned%20gaming%20aesthetic%2C%20crimson%20ambient%20light%2C%20abstract%20esports%20vibe%2C%20soft%20dramatic%20mood%2C%20editorial%20style%2C%20no%20text&width=600&height=600&seq=carousel-05-51cg&orientation=squarish',
  'https://readdy.ai/api/search-image?query=warm%20cinematic%20dark%20scene%20with%20crimson%20and%20amber%20accents%2C%20abstract%20film%20industry%20aesthetic%2C%20soft%20bokeh%20lights%2C%20editorial%20photography%2C%20no%20text%2C%20mysterious%20elegant&width=600&height=600&seq=carousel-06-51cg&orientation=squarish',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-3">
            焦点爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            本周最受关注的独家爆料专题，每一条都值得细品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer block"
            >
              <img
                src={carouselImages[idx]}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <h3 className="text-white font-heading font-bold text-lg md:text-xl leading-snug mb-1">
                  {item.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm">
                  {item.subtitle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}